const stockBalanceMainQueryKey = "stock-balance";
export { stockBalanceMainQueryKey };
